import Marquee from "react-fast-marquee";
import { useReducedMotion } from "framer-motion";
import { Asterisk } from "lucide-react";

const ITEMS = [
  "Aurora Unbound — Out Now",
  "The Storm Has Broken",
  "The Aurora Chronicles",
  "Michael B. Ford",
  "Book Two Available",
  "Northern Lights Rising",
];

export const MarqueeBand = () => {
  const reduced = useReducedMotion();
  return (
    <div
      data-testid="marquee-band"
      className="relative border-y border-white/10 bg-[#050505] py-7 overflow-hidden"
    >
      <Marquee speed={40} gradient gradientColor="#050505" gradientWidth={140} play={!reduced}>
        {ITEMS.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display italic font-light text-2xl md:text-4xl text-white/40 px-10 whitespace-nowrap">
              {t}
            </span>
            <Asterisk size={20} className="text-sky-500/60 shrink-0" />
          </span>
        ))}
      </Marquee>
    </div>
  );
};

export default MarqueeBand;
